import { render, staticRenderFns } from "./assessment-add-supplement.vue?vue&type=template&id=29c283db&scoped=true&"
import script from "./assessment-add-supplement.vue?vue&type=script&lang=js&"
export * from "./assessment-add-supplement.vue?vue&type=script&lang=js&"
import style0 from "./assessment-add-supplement.vue?vue&type=style&index=0&lang=css&"
import style1 from "./assessment-add-supplement.vue?vue&type=style&index=1&id=29c283db&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29c283db",
  null
  
)

export default component.exports